import { createGlobalStyle, styled } from "styled-components";

import { SidebarControlContentTitle } from "@/components/layout/Sidebar/SidebarControls/SidebarControl/SidebarControlContent/SidebarControlContentTitle";
import { FormControl } from "@/components/ui/FormControl";
import { Select } from "@/components/ui/Select";
import { notification } from "@/components/ui-deprecated";
import { getGrantedViewsFromRoles, viewDefinitions } from "@/features/views";
import { useAppDispatch, useAppSelector } from "@/store";
import { usePutUserSettingsMutation } from "@/store/services/user.service";
import { setActiveView } from "@/store/slices/user.slice";

type Props = {
    handleClose: () => void;
};

export const ACTIVE_VIEW_SWITCH_SELECT_CONTENT_CLASS = "active-view-switch-select-content";

const ActiveViewSwitchSelectContentGlobalStyle = createGlobalStyle`
    .${ACTIVE_VIEW_SWITCH_SELECT_CONTENT_CLASS} {
        z-index: ${({ theme }) => theme.zIndex.popover + 1};
    }
`;

const FormFields = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const ActiveViewSwitchContent = ({ handleClose }: Props) => {
    const dispatch = useAppDispatch();

    const activeView = useAppSelector((state) => state.user.activeView);
    const userId = useAppSelector((state) => state.user.id);
    const assignedRoles = useAppSelector((state) => state.user.assignedRoles);

    const grantedViewIds = getGrantedViewsFromRoles(assignedRoles);

    const [putUserSettings] = usePutUserSettingsMutation();

    const availableViews = grantedViewIds.map((viewId) => ({ value: viewId, label: viewDefinitions[viewId].label }));

    if (activeView === null || !(activeView in viewDefinitions)) return null; // Note: shouldn't happen

    const handleViewChange = async (value: string) => {
        if (!(value in viewDefinitions)) return;
        try {
            dispatch(setActiveView(value));
            putUserSettings({
                userId,
                params: {
                    name: "activeView",
                    value,
                },
            });
            handleClose();
        } catch (error) {
            console.error("Error updating active view", error);
            notification.danger("Active view update failed");
        }
    };

    return (
        <>
            <FormFields>
                <ActiveViewSwitchSelectContentGlobalStyle />
                <FormControl>
                    <SidebarControlContentTitle>Active View</SidebarControlContentTitle>
                    <Select
                        options={availableViews}
                        value={activeView ?? undefined}
                        getOptionValue={(option) => option.value}
                        getOptionLabel={(option) => option.label}
                        onValueChange={handleViewChange}
                        placeholder="Select active view"
                        contentClassName={ACTIVE_VIEW_SWITCH_SELECT_CONTENT_CLASS}
                    />
                </FormControl>
            </FormFields>
        </>
    );
};

export { ActiveViewSwitchContent };
